import React, { FC, memo } from 'react';
import classNames from 'classnames';
import BasicImage from '@home/components/BasicImage';
import type { ISkillLinkage } from '../../../types/skillDetail';
import SkillLinkageSessionPreview from '../SkillLinkageSessionPreview';
import './index.scss';

export interface ISkillLinkagePreviewProps {
  /** 当前激活案例 */
  activeLinkage: ISkillLinkage;
  /** 是否英文环境 */
  isEN: boolean;
  /** 是否启用数据请求 */
  enabled: boolean;
}

const PREFIX = 'dba-skill-linkage-preview';

/**
 * 联动案例预览：对话类展示会话/单轮，其余展示截图
 */
const SkillLinkagePreview: FC<ISkillLinkagePreviewProps> = ({
  activeLinkage,
  isEN,
  enabled,
}) => {
  const isConversation = activeLinkage.case_display_type === 'session_id';

  const title = isEN
    ? activeLinkage.title_en?.trim() || activeLinkage.title
    : activeLinkage.title;

  const screenshot = isEN
    ? activeLinkage.screenshot_url_en?.trim() || activeLinkage.screenshot_url
    : activeLinkage.screenshot_url;

  if (!isConversation && !screenshot) {
    return null;
  }

  return (
    <div
      className={classNames(PREFIX, {
        [`${PREFIX}--session`]: isConversation,
      })}
    >
      {isConversation ? (
        <SkillLinkageSessionPreview
          linkage={activeLinkage}
          isEN={isEN}
          enabled={enabled}
        />
      ) : (
        <BasicImage
          src={screenshot}
          alt={title}
          className={`${PREFIX}__screenshot`}
        />
      )}
    </div>
  );
};

export default memo(SkillLinkagePreview);
